<template>
  <div class="p-5 mb-4 bg-light rounded-3">
    <div class="container-fluid py-3">
      <h1 class="display-4">Vielen Dank!</h1>
      <p class="lead">Ihre E-Mail-Adresse wird bestätigt.</p>
      <p>Eine E-Mail wurde an Ihre E-Mail-Adresse versendet. Bitte öffnen Sie den Bestätigen-Link in der E-Mail.</p>
    </div>
  </div>
</template>
